import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { flowGradeColour } from "../constants/flowPresentation";
import { MOTION_EASE } from "../../../shared/constants/motion";

export default function FlowGradeBubble({ value, progress, colour, outOf, title }) {
  const reduceMotion = useReducedMotion();
  const ringColour = colour || flowGradeColour(value);
  const ringProgress = progress ?? ((value || 0) / 7 * 100);
  const circumference = 2 * Math.PI * 48;
  return (
    <div className="grade-bubble" title={title}>
      <svg className="grade-ring" viewBox="0 0 100 100" aria-hidden="true"><circle cx="50" cy="50" r="48" fill="none" stroke="#e9edf1" strokeWidth="4" /><motion.circle cx="50" cy="50" r="48" fill="none" stroke={ringColour} strokeWidth="4" strokeLinecap="round" strokeDasharray={circumference} transform="rotate(-90 50 50)" initial={reduceMotion ? false : { strokeDashoffset: circumference }} animate={{ strokeDashoffset: circumference * (1 - Math.max(0, Math.min(100, ringProgress)) / 100) }} transition={{ duration: reduceMotion ? 0 : 0.65, ease: MOTION_EASE.snap }} /></svg>
      <motion.output key={value ?? "empty"} initial={reduceMotion ? false : { opacity: 0.4, y: 4, scale: 0.94 }} animate={{ opacity: 1, y: 0, scale: 1 }} transition={{ duration: 0.42, ease: MOTION_EASE.snap }} style={{ color: colour || flowGradeColour(value) }}>{value ?? "--"}</motion.output>
      {outOf && <span className="out-of">/ {outOf}</span>}
    </div>
  );
}
